import { tryDark } from "../../Markup";

const homePageData = [
  {
    type: "Center",
    class: "wide extra-padding real-white-background",
    title: {
      class: ""
    },
    paragraph: [
      {
        class: "medium-title center-text dark-purple-text MankSans-Medium ",
        text: "Backends are needlessly complicated."
      },
      {
        class: "medium-title center-text dark-purple-text MankSans-Medium ",
        text:
          "Dark is a holistic programming language, editor, and infrastructure for building backends without accidental complexity."
      }
    ]
  },
  {
    type: "TwoColumn",
    class: "background-image purpleClouds video-container",
    columns: [
      {
        title: {
          class: "large-title lrg-margin-below MankSans-Medium",
          text: "Dark in Action"
        },
        type: "vid",
        src: "https://vimeo.com/360007420/01c205fe0f"
      },
      {
        title: {
          class: "large-title lrg-margin-below MankSans-Medium",
          text: "Dark's Philosophy"
        },
        type: "vid",
        src: "https://vimeo.com/360026719/100fd31003"
      }
    ]
  },
  {
    type: "TwoColumn",
    class: "short black-to-purple first-top-padding",
    columns: [
      {
        class: "fat",
        type: "text",
        rows: [
          {
            class: "medium-purple",
            title: {
              text: "Infrastructure",
              class: "large-title white-text"
            },
            paragraph: {
              class: "white-text small-title mankSans",
              text:
                "Dark reduces your infrastructure to four simple concepts: HTTP endpoints, datastores, background workers, and scheduled jobs. We host and automatically scale the infrastructure for you. We also host your static assets."
            }
          }
        ]
      },
      {
        class: "skinny"
      }
    ]
  },
  {
    type: "TwoColumn",
    class: "short purple-to-deeppurple",
    columns: [
      {
        class: "skinny"
      },
      {
        class: "fat",
        type: "text",
        rows: [
          {
            class: "medium-purple",
            title: {
              text: "Deployless",
              class: "large-title white-text align-right"
            },
            paragraph: {
              class: "white-text small-title mankSans align-right",
              text:
                "Speed of developer iteration is the single most important factor in how quickly a technology company can move. That’s why Dark deploys code in 50ms. We’ve built Dark from the ground up to make this safe, using feature flags as a replacement for deployments, sandboxes, different environments, and even version control."
            }
          }
        ]
      }
    ]
  },
  {
    type: "TwoColumn",
    class: "short deeppurple-to-black extra-space",
    columns: [
      {
        class: "fat",
        type: "text",
        rows: [
          {
            class: "medium-purple",
            title: {
              text: "Live values",
              class: "large-title white-text"
            },
            paragraph: {
              class: "white-text small-title mankSans",
              text:
                "See live requests made by your users, in your editor, in real-time. At any point while coding in Dark, you can see the real values of the expressions you're working on, updated live as you edit. It’s the best debugger we’ve ever used, a fantastic way to understand a codebase, and a great way to learn a language."
            }
          }
        ]
      },
      {
        class: "skinny"
      }
    ]
  },
  tryDark
];
export { homePageData };
